export default "__VITE_ASSET__DqDJSULJ__"